Stock = function() { Model.call(this); };

Stock.prototype             = new Stock();
Stock.prototype.constructor = Stock;

Stock.prototype.get_photos = function(stock_number, recycler_code, callbacks)
{
    this.ajax({
        url:       'Stock/photos/'+stock_number+'/'+recycler_code,
        type:      'GET',
        dataType:  'json',
        callbacks: callbacks
    });
};

Stock.prototype.get_all_photos = function(stock_number, file_number, recycler_code, callbacks)
{
    this.ajax({
        url:       'stock/all_photos/'+stock_number+'/'+file_number+'/'+recycler_code,
        type:      'GET',
        dataType:  'json',
        callbacks: callbacks
    });
};